// src/pages/admin/billing/AdminBillingHistoriquePage.js
import React from 'react';
import AdminLayout from '../../../components/admin/AdminLayout';

function AdminBillingHistoriquePage() {
  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Historique</h1>
      <p>Historique des opérations (devis, factures, paiements, stocks) à connecter à PocketBase.</p>
    </AdminLayout>
  );
}

export default AdminBillingHistoriquePage;
